import { Deployment } from './UpdateJobAssistant';
export interface UpdateJob extends Record<string, unknown> {
  uuid: string;
  createdAt: string;
  updatedAt: string;
  deviceCount: number;
  progress: Progress;
  deviceProgress: Record<string,DeviceProgress[]>;
  executedAt?: string;
}

export interface DeviceProgress {
  timestamp: string;
  progress: Progress;
  details: string;
}

export enum Progress{
  RETRYING = 'RETRYING',
  SUBMITTING = 'SUBMITTING',
  SOFTWAREUPDATE = 'SOFTWAREUPDATE',
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED',
  PARTIALLY_SUCCEEDED = 'PARTIALLY_SUCCEEDED',
  FAILED = 'FAILED',
  TIMEOUT = 'TIMEOUT',
  UNKNOWN = 'UNKNOWN',
  READY = 'READY',
  COMPLETED = 'COMPLETED'
}

export interface UpdateJobDeployment extends Deployment {
  uuid: string;
  createdAt: string;
  updatedAt: string;
  updateJob: {
    schedule: {
      runNow: boolean;
    };
    updateJobs: UpdateJob[];
    disabled?: boolean;
    status?: Progress;
  };
}
